import type { ReactNode } from 'react';

export type ModalMode = 'centered' | 'bottom-sheet' | 'fullscreen-mobile';

export type ModalProps = {
  isShow: boolean;
  children: ReactNode;
  isBackdrop?: boolean;
  onBackdropDismiss?: (closeModal: () => void) => void;
  className?: string;
  containerClassName?: string;
  /**
   * Layout mode of the modal body.
   * - `centered` (default) keeps the existing centered, fixed-width modal.
   * - `bottom-sheet` pins the body to the bottom on mobile (full-width with
   *   rounded top corners) and centers a wider modal on desktop.
   * - `fullscreen-mobile` fills the whole screen below the `md` breakpoint
   *   (phones: rounded top corners, no padding) and stays centered from `md`
   *   on (tablets and desktop), where
   *   the caller sizes it.
   */
  mode?: ModalMode;
  /** Disables backdrop click and ESC dismissal for blocking flows. Defaults to `true`. */
  isDismissible?: boolean;
  /**
   * ESC dismisses through `onBackdropDismiss`, like a backdrop click, so the
   * modal's own close (extra URL params, cleanup) runs. Defaults to `false`:
   * ESC calls `closeModal()` directly.
   */
  isEscapeLikeBackdrop?: boolean;
};

export enum ModalType {
  Auth = 'auth',
  BirthDate = 'birth-date',
  DeliveryAddress = 'delivery-address',
  DeliveryAddressList = 'delivery-address-list',
  DeliveryInfo = 'delivery-info',
  ChangeEmail = 'change-email',
  ChangeName = 'change-name',
  Comment = 'comment',
  ProductDetails = 'product-details',
  ChangeNotifications = 'change-notifications',
  Promocode = 'promocode',
  AddCard = 'add-card',
  DeleteAccount = 'delete-account',
  Logout = 'logout',
  DeleteAddress = 'delete-address',
  DeleteCard = 'delete-card',
  SelectDate = 'select-date',
  SelectDateCD = 'select-date-cd',
  Feedback = 'feedback',
  FeedbackSuccess = 'feedback-success',
  CreateReview = 'create-review',
  AgeRestriction = 'age-restriction',
  RateApp = 'rate-app',
  Recommendations = 'recommendations',
  CheckoutReciever = 'reciever-data',
  CheckoutAddRecieverData = 'add-reciever-data',
  Check3Ds = 'check-3ds',
  ReferralProgram = 'referral-program',
  SelectSKU = 'select-sku',
  Subscription = 'subscription',
  SubscriptionOff = 'subscription-off',
  EditAddressLocation = 'edit-address-location',
  EditAddressDetails = 'edit-address-details',
  OutOfZone = 'out-of-zone',
  DokobitVerification = 'dokobit-verification',
  TransactionDetails = 'transaction-details',
  Refund = 'refund',
  Geofencing = 'geofencing',
  DeliveryMethodChange = 'delivery-method-change',
  CheckoutDestination = 'checkout-destination',
  MembershipCancel = 'membership-cancel',
  MembershipPlanChange = 'membership-plan-change',
  ClubJoin = 'club-join',
  ClubCard = 'club-card',
}
